import React from 'react';

import { connect } from 'containers/store';

import { AccountAppState } from 'domains/account/store'
import { AuthSession } from 'domains/account/auth';

import { LoggedInRoutes, NotLoggedInRoutes } from './route-config';

type ConnectedProps = Pick<AccountAppState, 'config' | 'session'>

type Props = ConnectedProps;

class RoutesView extends React.PureComponent<Props, {}> {
  public render = () => {
    if (this.props.session) {
      return <LoggedInRoutes {...this.props} />;
    } else {
      return <NotLoggedInRoutes {...this.props} />;
    }
  }
}

export const Routes = connect<ConnectedProps, {}, {}>(
  (store) => ({
    config: store.account.config,
    session: store.account.session,
  }),
  undefined,
  undefined,
  { respondToRouteChanges: true },
)(RoutesView);
